import { AgentKnowledgeStatus } from "@redotech/cockroachdb-codegen/tables/agent-knowledge/agent-knowledge-status";
import { productKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const setProductKnowledgeStatus = {
  name: "setProductKnowledgeStatus" as const,
  input: z
    .object({
      ids: z.array(productKnowledgeIdFormat.schema),
      status: z.enum(AgentKnowledgeStatus),
    })
    .strict(),
  output: z.object({
    /** Ids that were missing or another account's count as not updated. */
    updatedCount: z.number(),
  }),
};
